import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AWSLambda } from 'src/app/AWSLambda.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-new-costumer',
  templateUrl: './newCostumer.component.html',
})
export class NewCostumerComponent implements OnInit {

  constructor(private lambda: AWSLambda) { }

  _snackBar = inject(MatSnackBar);

  Newcostumer: FormGroup = new FormGroup({
    nombre: new FormControl('', Validators.required),
    apellidos: new FormControl('', Validators.required),
    municipio: new FormControl('', Validators.required),
    postal: new FormControl('', Validators.required),
    id_fiscal: new FormControl(''),
    personafisica: new FormControl('1'),
    efectos_forma_pago: new FormControl('TARJ'),
    efectos_banco: new FormControl(''),
    factura_mail: new FormControl('1'),
    factura_papel: new FormControl('1'),
    tarifa_precio: new FormControl('1')
  });

  ngOnInit(): void {}

  onSubmit(): void {
    if (this.Newcostumer.valid) {
      const payload = {
        method: 'nuevo_cliente',
        ...this.Newcostumer.value
      };

      this.lambda.getLambdaFunction("lambda", "/isp/api", {
        queryStringParameters: payload
      }).then((result: any) => {
        if (result.ok) {
          this._snackBar.open('Cliente creado con éxito', 'Cerrar', {
            duration: 4000,
          });
        } else {
          this._snackBar.open('❌ Error: ' + result.message, 'Cerrar', {
            duration: 5000,
          });
        }
      }).catch((error: any) => {
        this._snackBar.open('❌ Error al crear el cliente. Intenta de nuevo.', 'Cerrar', {
          duration: 5000,
        });
        console.error('Error creando cliente:', error);
      });

      console.log('Payload listo para enviar:', payload);
    } else {
      console.warn('❌ El formulario no es válido');
      this._snackBar.open('Por favor completa todos los campos obligatorios.', 'Cerrar', {
        duration: 4000,
      });
    }
  }
}
